import {getFetchedJSON, fetchWithState, fetchWithStateTL} from '~/misc/fetch';

export const getPaymentHistoryApi = (getState) => {
  const state = getState();
  const id = state.user.id;
  return fetchWithStateTL(getState, {
    method: 'GET',
    header: {
      'Cache-control': 'no-cache',
      'Pragma': 'no-cache',
    },
    url: `/${id}/orders/succeed`,
  }).then(getFetchedJSON);
};

export const getPaymentNextBillDateApi = (getState) => {
  const state = getState();
  const id = state.user.id;

  return fetchWithStateTL(getState, {
    method: 'GET',
    header: {
      'Cache-control': 'no-cache',
      'Pragma': 'no-cache',
    },
    url: `/${id}/next-billing`,
  }).then(getFetchedJSON);
};

export const getAppPaymentHistoryApi = (getState) => {
  return fetchWithState(getState, {
    method: 'GET',
    header: {
      'Cache-control': 'no-cache',
      'Pragma': 'no-cache',
    },
    url: '/tl/paymentHistory',
  }).then(getFetchedJSON);
}



// WEBPACK FOOTER //
// ./src/modules/paymentHistoryPage/api.js